import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { ReportesInmobiliariasComponent } from './ReportesInmobiliarias.component';


import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';





const routes = [
    {
        path     : 'ReportesInmobiliarias',
        component: ReportesInmobiliariasComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ReportesInmobiliarias',
          nombreFormulario : 'ReportesInmobiliarias'
        } 
    }
];

@NgModule({
    declarations: [
        ReportesInmobiliariasComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ReportesInmobiliariasComponent
    ]
})

export class ReportesInmobiliariasModule
{
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ReportesInmobiliarias/ReportesInmobiliarias.module.ts